<script>
import EmojiConvertor from "emoji-js";
import ChatService from "@/services/ChatService";
import emojiShortcodes from "@/assets/emoji_shortcode.json";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    const emoji = new EmojiConvertor();
    emoji.replace_mode = "unified";
    emoji.allow_native = true;

    return {
      isLoading: false,
      defaultDataEmotion: {
        idIcon: "",
        name: "",
        key: "",
        order: null,
        isDefault: false,
        active: false,
        createdDate: ""
      },
      emojiSuggestions: emojiShortcodes,

      validation: {
        name: [
          {
            required: true,
            message: "Không để trống trường này!", trigger: "blur",
          }
        ],
        key: [
          {
            required: true,
            message: "Không để trống trường này!", trigger: "blur",
          }
        ]
      },

      emojiParser: emoji,
    }
  },

  watch: {},

  created() {

  },

  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetForm();
      // this.resetData();
      // this.handleAnimationButtonAddByIndex(this.currentQuestionIndex);
    },

    querySearch(queryString, cb) {
      const suggestions = this.emojiSuggestions
          .filter(item => item.toLowerCase().includes(queryString.toLowerCase()))// Giới hạn 15 gợi ý để tối ưu
          .map(item => ({
            value: item,
            emoji: this.convertToEmoji(item), // Lưu emoji để hiển thị
          }));
      cb(suggestions);
    },

    // Chuyển shortcode thành emoji
    convertToEmoji(shortcode) {
      return this.emojiParser.replace_colons(shortcode);
    },

    // Xử lý khi chọn gợi ý
    handleSelect(item) {
      this.defaultDataEmotion.key = item.value;
      this.onInputChange(item.value);
    },


    handleSaveForm() {
      this.$refs["defaultDataEmotion"].validate((valid) => {
        if (valid) {
          this.sendUpdateIcon();
        } else {
          return false;
        }
      });
    },

    resetForm() {
      this.$refs["defaultDataEmotion"].resetFields();
      this.defaultDataEmotion = {};
    },

    onInputChange(value) {
      // chuyển ký hiệu như ":)" thành emoji
      this.defaultDataEmotion.key = this.emojiParser.replace_emoticons(value);
    },

    sendUpdateIcon() {
      this.isLoading = true;
      ChatService.emotionService.update(this.defaultDataEmotion)
          .then(res => {
            const data = res.data.data;
            this.$message({message: res.data.message, type: data != null ? "success" : "error"});
            this.$emit("success", data);
            this.resetForm();
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    initialDataUpdate(data) {
      this.defaultDataEmotion = {
        idIcon: data.idIcon,
        name: data.name,
        key: data.key,
        order: data.order,
        createdDate: data.createdDate,
        isDefault: data.isDefault,
        active: data.active,
      };
    }
  }
}
</script>

<template>
  <div>
    <section>
      <el-dialog
          :before-close="handleClose"
          :visible.sync="isOpen"
          :show-close="true"
          width="25%"
          class="create_dialog"
      >
        <template #title>
          <div class="title_dialog">
            <span>Chỉnh sửa emotion</span>
          </div>
        </template>

        <el-form :model="defaultDataEmotion" :rules="validation" ref="defaultDataEmotion">
          <section class="dialog_body">
            <el-row>
              <el-col :span="24">
                <div class="wrapper_input">
                  <el-form-item label="Tên emotion: " prop="name">
                    <el-input
                        placeholder="Nhập tên Emotion"
                        prefix-icon="el-icon-edit"
                        v-model="defaultDataEmotion.name">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="wrapper_input">
                  <el-form-item label="Emotion: " prop="key">
                    <el-autocomplete
                        style="width: 100%"
                        placeholder="Nhập Emotion (VD: :smile:)"
                        prefix-icon="el-icon-edit"
                        v-model="defaultDataEmotion.key"
                        :fetch-suggestions="querySearch"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        @input="onInputChange">
                      <template slot-scope="{ item }">
                        <div class="icon" style="display: flex; justify-content: space-between;">
                          <span>{{ item.value }}</span>
                          <span>{{ convertToEmoji(item.value) }}</span>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </section>
        </el-form>

        <section slot="footer">
          <el-button @click="handleClose" icon="el-icon-circle-close" type="danger">
            Hủy bỏ
          </el-button>
          <el-button type="success" @click="handleSaveForm()" icon="el-icon-circle-check" :loading="isLoading">
            Lưu
          </el-button>
        </section>
      </el-dialog>
    </section>
  </div>
</template>

<style scoped lang="scss">
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.label_dialog {
  margin-bottom: 4px;
  display: block;
  font-weight: 500;
  font-family: Arial, sans-serif;
}
</style>